var map = {
	"./FakeTimers": 311,
	"./FakeTimers.js": 311,
	"./__tests__/FakeTimers-test": 564,
	"./__tests__/FakeTimers-test.js": 564,
	"./__tests__/moduleMocker-test": 565,
	"./__tests__/moduleMocker-test.js": 565,
	"./__tests__/utils-normalizeConfig-test": 566,
	"./__tests__/utils-normalizeConfig-test.js": 566,
	"./__tests__/utils-pathNormalize-test": 567,
	"./__tests__/utils-pathNormalize-test.js": 567,
	"./colors": 172,
	"./colors.js": 172,
	"./moduleMocker": 242,
	"./moduleMocker.js": 242,
	"./promiseDone": 389,
	"./promiseDone.js": 389,
	"./testLogger": 390,
	"./testLogger.js": 390,
	"./utils": 46,
	"./utils.js": 46
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3130;



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/lib ^\.\/.*$
// module id = 3130
// module chunks = 0